module.exports = __webpack_public_path__ + "img/Stemness-BRCA_10X_WTA.06380178.png";